



























































import InformationRow from '@/components/display/information-row.vue';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import FormInputRow from '@/components/form pickers/FormInputRow.vue';
import { ConsentCondition, ConsentWithId } from '@/api';
import { ConsentConditionModule, ConsentCouncil } from '@/modules';
import WaterConsentConditionEditModal from '@/components/display/water-consents/conditions/water-consent-condition-edit-modal.vue';
import { ApiUtils } from '@/common/ApiUtils';
import Toast from '@/components/display/toast.vue';
import ConfirmModal from '@/components/display/confirm-modal.vue';

@Component({
	components: {
		ConfirmModal,
		WaterConsentConditionEditModal,
		FormInputRow,
		InformationRow,
	},
})
export default class WaterConsentConditions extends Vue {
	private readonly toast: Toast = new Toast();
	private readonly consentConditionModule: ConsentConditionModule = new ConsentConditionModule();

	@Prop({ required: true })
	public productId!: number;

	@Prop({ required: true })
	public consent!: ConsentWithId &
		ConsentCouncil & { active?: boolean; consentconditions?: ConsentCondition[] };

	protected consentConditions: ConsentCondition[] = [];
	protected selectedConsentCondition: ConsentCondition = {};

	protected deleteConsentCondition?: ConsentCondition | null;
	protected deletingConsentCondition: boolean = false;

	protected readonly consentConditionFields: { key: string; label: string }[] = [
		{ key: 'consentconditiontype.name', label: 'Consent Condition Type' },
		{ key: 'displayText', label: 'Display Text' },
		{ key: 'actions', label: '' },
	];

	public async mounted() {
		this.onConsentChanged();
	}

	@Watch('consent', { deep: true })
	public onConsentChanged() {
		this.consentConditions = this.consent.consentconditions ?? [];
	}

	public openModal(consentCondition?: ConsentCondition): void {
		this.selectedConsentCondition = consentCondition ?? {};
		this.$bvModal.show('addEditWaterConsentConditionModal');
	}

	protected onSavedConsentCondition(consentCondition: ConsentCondition): void {
		const existingIndex = this.consentConditions.findIndex(c => c.id == consentCondition.id);
		const existing = this.consentConditions[existingIndex];
		if (existingIndex >= 0)
			this.consentConditions.splice(existingIndex, 1, {
				...existing,
				...consentCondition,
			});
		else this.doReloadConsents();
	}

	protected openDeleteConsentCondition(consentCondition?: ConsentCondition): void {
		this.deleteConsentCondition = consentCondition;
		this.$bvModal.show('deleteWaterConsentConditionModal');
	}

	public async onDeleteConsentCondition(consentCondition?: ConsentCondition | null): Promise<void> {
		if (consentCondition?.id) {
			this.deletingConsentCondition = true;
			try {
				await this.consentConditionModule.delete(consentCondition.id);
				const index = this.consentConditions.findIndex(c => c.id === consentCondition.id);
				if (index >= 0) this.consentConditions.splice(index, 1);
				this.$bvModal.hide('deleteWaterConsentConditionModal');
			} catch (e) {
				const { errorMessage } = ApiUtils.handleApiError(
					e,
					'There was an issue deleting the consent condition',
				);
				this.toast.makeToast(errorMessage, 'Error', 'danger');
			}
			this.deletingConsentCondition = false;
		}
	}

	@Emit('reloadConsents')
	private doReloadConsents(): void {}
}
